// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://bscscan.com/address/0xff75B6da14FfbbfD355Daf7a2731456b3562Ba6D
export const POOL_ADDRESSES_PROVIDER = '0xff75B6da14FfbbfD355Daf7a2731456b3562Ba6D';

// IPool https://bscscan.com/address/0x6807dc923806fE8Fd134338EABCA509979a7e0cB
export const POOL = '0x6807dc923806fE8Fd134338EABCA509979a7e0cB';

// IPoolConfigurator https://bscscan.com/address/0x67bdF23C7fCE7C65fF7415Ba3F2520B45D6f9584
export const POOL_CONFIGURATOR = '0x67bdF23C7fCE7C65fF7415Ba3F2520B45D6f9584';

// IAaveOracle https://bscscan.com/address/0x39bc1bfDa2130d6Bb6DBEfd366939b4c7aa7C697
export const ORACLE = '0x39bc1bfDa2130d6Bb6DBEfd366939b4c7aa7C697';

// https://bscscan.com/address/0x9390B1735def18560c509E2d0bc090E9d6BA257a
export const ACL_ADMIN = '0x9390B1735def18560c509E2d0bc090E9d6BA257a';

// IACLManager https://bscscan.com/address/0x2D97F8FA96886Fd923c065F5457F9DDd494e3877
export const ACL_MANAGER = '0x2D97F8FA96886Fd923c065F5457F9DDd494e3877';

// IPoolDataProvider https://bscscan.com/address/0xc90Df74A7c16245c5F5C5870327Ceb38Fe5d5328
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xc90Df74A7c16245c5F5C5870327Ceb38Fe5d5328';

// https://bscscan.com/address/0x00d1397960aa97F694E41C3632b74c151a00c33B
export const POOL_IMPL = '0x00d1397960aa97F694E41C3632b74c151a00c33B';

// https://bscscan.com/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://bscscan.com/address/0xC206C2764A9dBF27d599613b8F9A63ACd1160ab4
export const DEFAULT_INCENTIVES_CONTROLLER = '0xC206C2764A9dBF27d599613b8F9A63ACd1160ab4';

// https://bscscan.com/address/0x6eD1c70aa357fB8a7e1Eac85aa59e33287Df8f85
export const EMISSION_MANAGER = '0x6eD1c70aa357fB8a7e1Eac85aa59e33287Df8f85';

// ICollector https://bscscan.com/address/0x25Ec457d1778b0E5316e7f38f3c22baF413F1A8C
export const COLLECTOR = '0x25Ec457d1778b0E5316e7f38f3c22baF413F1A8C';

// https://bscscan.com/address/0x7e199Fc666368d95B9EaEfA7D2d8081AcAb74134
export const DEFAULT_A_TOKEN_IMPL = '0x7e199Fc666368d95B9EaEfA7D2d8081AcAb74134';

// https://bscscan.com/address/0x929CD8EE3d0b6e04324Ee1171D4f594a2c47166d
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x929CD8EE3d0b6e04324Ee1171D4f594a2c47166d';

// https://bscscan.com/address/0x87F4aDD5425f566F156af5074BaD2dFFCd20C594
export const RISK_STEWARD = '0x87F4aDD5425f566F156af5074BaD2dFFCd20C594';

// https://bscscan.com/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const DEBT_SWAP_ADAPTER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

// https://bscscan.com/address/0x69A45013F047A65422deFdD0C43f09530D7025c0
export const CONFIG_ENGINE = '0x69A45013F047A65422deFdD0C43f09530D7025c0';

// https://bscscan.com/address/0x117684358D990E42Eb1649E7e8C4691951dc1E71
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x117684358D990E42Eb1649E7e8C4691951dc1E71';

// https://bscscan.com/address/0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9';

// https://bscscan.com/address/0x33E0b3fc976DC9C516926BA48CfC0A9E10a2aAA5
export const SWAP_COLLATERAL_ADAPTER = '0x33E0b3fc976DC9C516926BA48CfC0A9E10a2aAA5';

// https://bscscan.com/address/0x5c5228aC8BC1528482514aF3e27E692495148717
export const UI_INCENTIVE_DATA_PROVIDER = '0x5c5228aC8BC1528482514aF3e27E692495148717';

// https://bscscan.com/address/0x632b5Dfc315b228bfE779E6442322Ad8a110Ea13
export const UI_POOL_DATA_PROVIDER = '0x632b5Dfc315b228bfE779E6442322Ad8a110Ea13';

// https://bscscan.com/address/0x36616cf17557639614c1cdDb356b1B83fc0B2132
export const WALLET_BALANCE_PROVIDER = '0x36616cf17557639614c1cdDb356b1B83fc0B2132';

// https://bscscan.com/address/0x0c2C95b24529664fE55D4437D7A31175CFE6c4f7
export const WETH_GATEWAY = '0x0c2C95b24529664fE55D4437D7A31175CFE6c4f7';

// https://bscscan.com/address/0x5E2d083417D12d4B0824E14Ecd48D26831F4Da7D
export const WITHDRAW_SWAP_ADAPTER = '0x5E2d083417D12d4B0824E14Ecd48D26831F4Da7D';

// https://bscscan.com/address/0x326aB0868bD279382Be2DF5E228Cb8AF38649AB4
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x326aB0868bD279382Be2DF5E228Cb8AF38649AB4';

// https://bscscan.com/address/0x3870D459d2fC2Edbb03E0DdeE6c0Ccb268caf202
export const DUST_BIN = '0x3870D459d2fC2Edbb03E0DdeE6c0Ccb268caf202';

// https://bscscan.com/address/0x9e842f55Fdbb8F332D7c7aCe2B67fa5e4CCAAc43
export const CLINIC_STEWARD = '0x9e842f55Fdbb8F332D7c7aCe2B67fa5e4CCAAc43';

// https://bscscan.com/address/0x58AfE45eE7D7f2AE9c26827F33A6f319Feb68Df8
export const POOL_EXPOSURE_STEWARD = '0x58AfE45eE7D7f2AE9c26827F33A6f319Feb68Df8';

// https://bscscan.com/address/0x929B8a21a604b93DD7e95d5b9aAa3aDf5bE250ae
export const STATA_FACTORY = '0x929B8a21a604b93DD7e95d5b9aAa3aDf5bE250ae';

// https://bscscan.com/address/0x239d3Bc5fa247337287cb03f53B8bc63DBBc332D
export const EDGE_RISK_ORACLE = '0x239d3Bc5fa247337287cb03f53B8bc63DBBc332D';

// https://bscscan.com/address/0x655252250f4A453854040A49E8280951A76f3033
export const EDGE_RISK_STEWARD_CAPS = '0x655252250f4A453854040A49E8280951A76f3033';

// https://bscscan.com/address/0x54714FAc85b0bf627288CC3a186dE81A42f1D635
export const EDGE_INJECTOR_CAPS = '0x54714FAc85b0bf627288CC3a186dE81A42f1D635';

export const CHAIN_ID = 56;
export const ASSETS = {
  Cake: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    A_TOKEN: '0x4199CC1F5ed0d796563d7CcB2e036253E2C18281',
    V_TOKEN: '0xE20dBC7119c635B1B51462f844861258770e0699',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xB6064eD41d4f67e353768aA239cA86f4F73665a1',
    STATIC_A_TOKEN: '0x3854354CE3681da1D7F550073061E92a4a7d1B27',
  },
  WBNB: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    A_TOKEN: '0x9B00a09492a626678E5A3009982191586C444Df9',
    V_TOKEN: '0x0E76414d433ddfe8004d2A7505d218874875a996',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE',
    STATIC_A_TOKEN: '0x436baCb4C66583de4Cb16e13a1A0D9A3075DE425',
  },
  BTCB: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    A_TOKEN: '0x56a7ddc4e848EbF43845854205ad71D5D5F72d3D',
    V_TOKEN: '0x7b1E82F4f542fbB25D64c5523Fe3e44aBe4F2702',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x264990fbd0A4796A3E3d8E37C4d5F87a3aCa5Ebf',
    STATIC_A_TOKEN: '0x1F66b530084079d35478A069d9c4424F9c9C320c',
  },
  ETH: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    A_TOKEN: '0x2E94171493fAbE316b6205f1585779C887771E2F',
    V_TOKEN: '0x8FDea7891b4D6dbdc746309245B316aF691A636C',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x9ef1B8c0E4F7dc8bF5719Ea496883DC6401d5b2e',
    STATIC_A_TOKEN: '0x52077433fB7053D747E2846aD0C18ff5015C368E',
  },
  USDC: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    A_TOKEN: '0x00901a076785e0906d1028c7d6372d247bec7d61',
    V_TOKEN: '0xcDBBEd5606d9c5C98eEedd67933991dC17F0c68d',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x9102a9553B470dbD0dC74009a870A5886C92902C',
    STATIC_A_TOKEN: '0x3906cDdfb781f02B21f21BD81ed7Fd8DC37075E1',
  },
  USDT: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x55d398326f99059fF775485246999027B3197955',
    A_TOKEN: '0xa9251ca9DE909CB71783723713B21E4233fbf1B1',
    V_TOKEN: '0xF8bb2Be50647447Fb355e3a77b81be4db64107cd',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xee845A7A40A090Da256420A293803C35B7F436b6',
    STATIC_A_TOKEN: '0x0471D185cc7Be61E154277cAB2396cD397663da6',
  },
  FDUSD: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409',
    A_TOKEN: '0x75bd1A659bdC62e4C313950d44A2416faB43E785',
    V_TOKEN: '0xE628B8a123e6037f1542e662B9F55141a16945C8',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x72Cb7a00D439296A6fC3c9face9Eca96bfdEf825',
    STATIC_A_TOKEN: '0x4d074aAa0821073dA827f7bf6a02cF905b394ed0',
  },
  wstETH: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x26c5e01524d2E6280A48F2c50fF6De7e52E9611C',
    A_TOKEN: '0xBDFd4E51D3c14a232135f04988a42576eFb31519',
    V_TOKEN: '0x2c391998308c56D7572A8F501D58CB56fB9Fe1C5',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xc1377B4cdF9116bf7b3d7F72A4f8A7Be8506cE80',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'wstETH / ETH',
    collateralBitmap: '128',
    collateralAssets: ['0x26c5e01524d2E6280A48F2c50fF6De7e52E9611C'],
    borrowableBitmap: '8',
    borrowableAssets: ['0x2170Ed0880ac9A755fd29B2688956BD959F933F8'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
